import { Select, TextField } from '@components/base/inputs';
import { VStack } from '@components/base/layout';
import { useErpSelect } from './useErpSelect';

interface ErpLoginConfigPanelProps {
  readonly getValue: (field: string) => unknown;
  readonly setValue: (field: string, value: unknown) => void;
}

export function ErpLoginConfigPanel({
  getValue,
  setValue,
}: Readonly<ErpLoginConfigPanelProps>) {
  const { registries } = useErpSelect();

  return (
    <VStack gap={4}>
      <Select
        label="ERP Registry"
        required
        options={registries}
        value={(getValue('config_erp_slug') as string) ?? ''}
        onChange={(value) => setValue('config_erp_slug', value)}
        placeholder="Select an ERP registry"
      />

      <TextField
        label="UID"
        placeholder="Fallback user ID"
        helperText="Optional. Used if not configured in registry auth_config."
        value={(getValue('config_uid') as string) ?? ''}
        onChange={(e) => setValue('config_uid', e.target.value)}
      />

      <TextField
        label="Password"
        type="password"
        placeholder="Fallback password"
        helperText="Optional. Used if not configured in registry auth_config."
        value={(getValue('config_password') as string) ?? ''}
        onChange={(e) => setValue('config_password', e.target.value)}
      />

      <TextField
        label="Language"
        placeholder="fr"
        helperText="Optional. Defaults to 'fr'."
        value={(getValue('config_language') as string) ?? ''}
        onChange={(e) => setValue('config_language', e.target.value)}
      />
    </VStack>
  );
}
